module.exports = "<div class=\"callout\" [ngClass]=\"type\" [class.hidden]=\"!message\">\n    {{message}}\n    <button class=\"close-button\" type=\"button\" (click)=\"onClose()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/modules/shared/components/alert-box/AlertBoxComponent.html
// module id = 112
// module chunks = 0